import {useDispatch, useSelector} from 'react-redux'
import {useEffect, useState} from 'react'
import {getUpgradedPlan, setGlobalInfo, setSessionIdExist} from '../../../stores/sidebar'
import useInterval from 'use-interval'
import {toast} from 'react-toastify'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'

const SubscriptionSession = () => {
    const checkingPlanUpdatingCountLimit = 50
    const checkingPlanUpdatingInterval = 5000
    const text = useNamespaceTranslations('main-layout')
    const currentPlan = localStorage.getItem('plan')
    const upgradedPlan = localStorage.getItem('upgradedPlan')
    const sessionIdExist = useSelector(state => state.sidebar.sessionIdExist)
    const [checkingPlanUpdatingCount, setCheckingPlanUpdatingCount] = useState(0)
    const [isPlanUpgraded, setIsPlanUpgraded] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        setIsPlanUpgraded(false)
        const condition = localStorage.getItem('plan') !== localStorage.getItem('upgradedPlan')
        sessionIdExist && condition ? dispatch(setGlobalInfo(text.plan_upgrading)) : dispatch(setGlobalInfo(''))
    }, [sessionIdExist])

    useInterval(() => {
        const currentPlan = localStorage.getItem('plan')
        if (!sessionIdExist) {
            return
        }
        if (currentPlan === upgradedPlan) {
            toast.success(text.plan_updated)
            setIsPlanUpgraded(true)
            dispatch(setSessionIdExist(''))
            return
        }
        setCheckingPlanUpdatingCount(checkingPlanUpdatingCount + 1)
        dispatch(getUpgradedPlan())
    }, (currentPlan === upgradedPlan || checkingPlanUpdatingCount > checkingPlanUpdatingCountLimit || !sessionIdExist || isPlanUpgraded) ? null : checkingPlanUpdatingInterval)

    return null
}

export default SubscriptionSession
